<template>
  <div class="pricing-table-wrapper">
    <v-simple-table fixed-header>
      <template v-slot:default>
        <thead>
          <tr>
            <th class="text-left text-h6">Type</th>
            <th class="text-right text-h6">Full Time</th>
            <th class="text-right text-h6">Part Time</th>
          </tr>
        </thead>
        <tbody>
          <tr v-for="(row, index) in tableRows" :key="index">
            <td class="font-weight-medium text-subtitle-1">{{ row.label }}</td>
            <td class="text-right text-subtitle-1 font-weight-medium text-info">
              <template v-if="loading">
                <span
                  class="skeleton skeleton-line"
                  style="width: 80px; display: inline-block"
                ></span>
              </template>
              <template v-else>
                {{ formatValue(getValue("full_time", row.key)) }}
              </template>
            </td>
            <td class="text-right text-subtitle-1 font-weight-medium text-info">
              <template v-if="loading">
                <span
                  class="skeleton skeleton-line"
                  style="width: 80px; display: inline-block"
                ></span>
              </template>
              <template v-else>
                {{ formatValue(getValue("part_time", row.key)) }}
              </template>
            </td>
          </tr>
        </tbody>
      </template>
    </v-simple-table>
  </div>
</template>

<script>
export default {
  name: "NominateTalentToClientPricingTable",
  props: {
    pricingData: {
      type: Object,
      default: () => null,
    },
    loading: {
      type: Boolean,
      default: false,
    },
    fullTimeMargin: {
      type: Number,
      default: 0,
    },
    partTimeMargin: {
      type: Number,
      default: 0,
    },
  },
  data() {
    return {
      tableRows: [
        { label: "Salary", key: "salary" },
        { label: "WHT", key: "wht" },
        { label: "GOSI", key: "social_insurance" },
        { label: "Medical Insurance", key: "medical_insurance" },
        { label: "EOS", key: "end_of_service" },
        { label: "Leave Balance", key: "leave_balance" },
        { label: "Total Salary", key: "total_salary" },
      ],
    };
  },
  methods: {
    getValue(type, key) {
      if (!this.pricingData || !this.pricingData[type]) {
        return null;
      }
      return this.pricingData[type][key];
    },
    formatValue(value) {
      if (value === null || value === undefined || value === "") {
        return "-";
      }
      // Format numbers with dollar sign and commas if it's a number
      if (typeof value === "number") {
        return `$${value.toLocaleString()}`;
      }
      return value;
    },
  },
  watch: {
    fullTimeMargin(newVal, oldVal) {
      this.pricingData.full_time.total_salary =
        this.pricingData.full_time.total_salary - oldVal + newVal;
    },
    partTimeMargin(newVal, oldVal) {
      this.pricingData.part_time.total_salary =
        this.pricingData.part_time.total_salary - oldVal + newVal;
    },
  },
};
</script>

<style lang="scss" scoped>
.pricing-table-wrapper {
  width: 100%;
  max-height: 200px;
  overflow-y: auto;
  border: 1px solid #e0e0e0;
  border-radius: 4px;
}

.skeleton {
  display: block;
  background: linear-gradient(90deg, #eeeeee 25%, #f5f5f5 37%, #eeeeee 63%);
  background-size: 400% 100%;
  animation: skeleton-loading 1.4s ease infinite;
  border-radius: 4px;
  min-height: 18px;
}

.skeleton-line {
  height: 18px;
}

@keyframes skeleton-loading {
  0% {
    background-position: 100% 50%;
  }
  100% {
    background-position: 0 50%;
  }
}

::v-deep .v-simple-table {
  table {
    border-collapse: collapse;
    thead {
      tr {
        th {
          font-weight: 600;
          background-color: #f5f5f5;
          border: 1px solid #e0e0e0;
          border-bottom: 2px solid #e0e0e0;
        }
      }
    }
    tbody {
      tr {
        td {
          padding: 12px 16px;
          border: 1px solid #e0e0e0;
        }
        &:last-child {
          td {
            border-bottom: 1px solid #e0e0e0;
          }
        }
      }
    }
  }
}
</style>
